import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormControl, TextField, Typography } from '@mui/material';
import type { ArrayHelpers } from 'formik';

import type { RootCause } from 'src/types/followUp';

import { styles } from 'src/components/survey/SurveySettings/index.styles';

interface AddNewRootCauseProps extends Pick<ArrayHelpers, 'unshift'> {
  rootCauses: Array<RootCause>;
}

const AddNewRootCause: FC<AddNewRootCauseProps> = ({ unshift, rootCauses }) => {
  const { t } = useTranslation('survey');
  const [newRootCause, setNewRootCause] = useState('');
  const handleSubmit = () => {
    unshift({
      name: newRootCause,
      isActive: false,
      id: -1 - rootCauses.length, // placeholder id for react
    });
    setNewRootCause('');
  };
  return (
    <FormControl sx={styles.addRootCauseInput}>
      <Typography component="label" htmlFor="newRootCause">
        {t('settings.followUpModule.addRootCauses')}
      </Typography>
      <TextField
        id="newRootCause"
        placeholder={t('settings.followUpModule.enterRootCause')}
        value={newRootCause}
        onChange={(event) => {
          setNewRootCause(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (newRootCause) {
              handleSubmit();
            }
          }
        }}
        InputProps={{
          endAdornment: (
            <Button
              sx={styles.addRootCauseButton}
              disabled={!newRootCause}
              onClick={() => {
                handleSubmit();
              }}
            >
              {t('settings.followUpModule.addRootCause')}
            </Button>
          ),
        }}
      />
    </FormControl>
  );
};

export default AddNewRootCause;
